import { Option } from '@clean-code/types/common';
import { ComparisonData, OverwritingStopClassificationError } from './types';

export const buildComparisonData = (
  overwritingStopClassificationError: OverwritingStopClassificationError,
  generalCauseOptions: Option[],
  components: Option[],
  getSpecificCauses: (generalCauseId: string | null) => Option[]
): ComparisonData[] => {
  const current =
    overwritingStopClassificationError.details.currentStopClassification;
  const newStopClassification =
    overwritingStopClassificationError.details.newStopClassification;
  const currentGeneralCause = generalCauseOptions.find(
    (option) => option.value === current.stopGeneralCauseId
  );
  const newGeneralCause = generalCauseOptions.find(
    (option) => option.value === newStopClassification.generalCauseId
  );
  const currentSpecificCause = getSpecificCauses(
    current.stopGeneralCauseId
  ).find((option) => option.value === current.stopSpecificCauseId);
  const newSpecificCause = getSpecificCauses(
    newStopClassification.generalCauseId
  ).find((option) => option.value === newStopClassification.specificCauseId);
  const currentComponent = components.find(
    (option) => option.value === current.componentId
  );
  const newComponent = components.find(
    (option) => option.value === newStopClassification.componentId
  );
  return [
    {
      field: 'general_cause',
      current: currentGeneralCause?.label ?? null,
      new: newGeneralCause?.label ?? null
    },
    {
      field: 'specific_cause',
      current: currentSpecificCause?.label ?? null,
      new: newSpecificCause?.label ?? null
    },
    {
      field: 'equipment',
      current: currentComponent?.label ?? null,
      new: newComponent?.label ?? null
    },
    {
      field: 'description',
      current: current.description ?? null,
      new: newStopClassification.description ?? null
    }
  ];
};
